import classNames from "classnames";
import CustomModalHeader from "~/features/scanDmc/components/CustomModalHeader/CustomModalHeader";
import { Button, Stack, styled, Typography } from "~/common/mui";
import Modal from "~/common/components/Modal";
import { CheckboxWithLabel } from "~/common/components/CheckboxWithLabel";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DmcIntroImage } from "~/features/scanDmc/components/DMCIntroOverlay/DmcIntroImage";
import { getOS } from "~/common/utils/browserChecks";
import { IconSize } from "~/common/mui/icons/IconSize";
import { HOMEPAGE } from "~/utils/url/staticUrls";
import { BackLink } from "~/common/components/Link";
import { Alert } from "~/common/mui/Alert/Alert";

const PageTitle = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  color: theme.palette.primary.main,
}));

const ImageTitle = styled(Typography)({
  fontWeight: "bold",
});

const ImageContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gap: theme.spacing(2),
  gridTemplateColumns: "100%",
}));

interface Props {
  onReturn: (dontShowAgain: boolean) => void;
  className?: string;
  dontShowAgain: boolean;
}

export const DMCIntroOverlay = (props: Props) => {
  const { t } = useTranslation();
  const [dontShowAgainChecked, setDontShowAgainChecked] = useState(props.dontShowAgain);

  const [isIOS] = useState(() => getOS() === "iOS");

  const closeCb = () => props.onReturn(dontShowAgainChecked);
  return (
    <Modal
      headerOverride={<CustomModalHeader />}
      onClose={() => undefined}
      footerChildren={
        <Button fullWidth={true} onClick={closeCb}>
          {t("page.scandmc.help.closeBtn")}
        </Button>
      }
      footerClassName={"scha__modal__footer--border"}
    >
      <Stack className={props.className} sx={{ gap: 4, "& p": { margin: 0 } }}>
        <BackLink iconSize={IconSize.FONT_24} href={HOMEPAGE}>
          {t("navigation.home")}
        </BackLink>
        <Stack sx={{ gap: 2 }}>
          <PageTitle variant="headlineSmall">{t("page.scandmc.help.title")}</PageTitle>
          <p>{t("page.scandmc.help.instructions")}</p>
        </Stack>
        <Stack sx={{ gap: 2 }}>
          <ImageTitle variant="titleLarge">{t("page.scandmc.help.imageTitle")}</ImageTitle>
          <ImageContainer>
            <DmcIntroImage />
          </ImageContainer>
          {isIOS && <Alert severity={"info"}>{t("page.scandmc.iospermission")}</Alert>}
        </Stack>
        {!props.dontShowAgain && (
          <CheckboxWithLabel onCheck={setDontShowAgainChecked}>
            {t("page.scandmc.help.dontShowAgain")}
          </CheckboxWithLabel>
        )}
      </Stack>
    </Modal>
  );
};
